import { RolodexRecordStatus } from '../../../../../../../../../graphql';

export const STATUS_OPTIONS = [
  { label: 'Effective', value: RolodexRecordStatus.Effective },
  { label: 'Deleted', value: RolodexRecordStatus.Deleted },
];

export const EMPTY_OPTIONS = [];
